//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { ref, onBeforeMount, onMounted } from '@vue/composition-api'
import {
  mdiCalendarOutline,
  mdiSoccerField,
  mdiClockOutline,
  mdiInformationOutline,
  mdiShareOutline,
} from '@mdi/js'
import { useUtils } from '@core/libs/i18n'
import { useRouter, formatCurrency } from '@core/utils'
import themeConfig from '@themeConfig'
import moment from 'moment'

import Vue from 'vue'
import infiniteScroll from 'vue-infinite-scroll'

import useLogData from '@core/utils/useLogData'
import useVideoData from '@core/utils/useVideoData'
import useCryptoJs from '@core/utils/useCryptoJs'
import useShare from '@/@core/utils/useShare'

import useLanding from '@/views/landing/useLanding'

import AppBarUserAvatar from '@core/layouts/components/app-bar/AppBarUserAvatar.vue'
import Report from '@/views/landing/components/report/Report.vue'
import Share from '@/views/components/share/Share.vue'
import VideoChips from './VideoChips.vue'

import useVideos from './useVideos'

export default {
  components: {
    AppBarUserAvatar,
    Report,
    VideoChips,
    Share,
  },
  setup() {
    const { t } = useUtils()
    const { router, route } = useRouter()
    const { userData } = useCryptoJs()
    const { logData, updateLogData, clearLogData } = useLogData()
    const { videoData, currentVideoData, updateVideoData } = useVideoData()
    const {
      facilities,
      fields,
      startTimes,
      recordings,
      hasRecordings,
      lastItemId,
      busy,
      isDialogReport,

      facilitySelected,
      facilityIdSelected,

      minDate,
      maxDate,
      modal,
      dateFilter,
      fieldFilter,
      timeFilter,
      computedDateFormatted,

      fetchFacilities,
      onLoadMore,
      onReportIssue,
      refreshRoure,
    } = useVideos()

    const {
      paymentMethods,
      fetchPaymentMethods,
    } = useLanding()
    const { shareURL, isSupportedShare } = useShare()

    const isDialogShare = ref(false)
    const shareData = ref({})
    const privateLanding = ref(false)

    const formatVideoName = videoDate => moment(`${videoDate}`, 'YYYY-MM-DD hh:mm').format('dddd HH:mm, MMM DD')

    const onLogin = async () => {
      logData.value.joinGame = 'NO'
      logData.value.matchCode = null
      logData.value.redirect = 'videos'
      logData.value.facility = facilitySelected.value
      logData.value.field = fieldFilter.value || 'all'
      logData.value.date = dateFilter.value || 'all'
      logData.value.time = timeFilter.value || 'all'
      await updateLogData(logData.value)

      router.push({ name: 'auth-login-phone-email' })
    }

    const onLogout = async () => {
      await localStorage.removeItem('userData')
      privateLanding.value = false
    }

    const onLoadVideo = async video => {
      if (privateLanding.value) await fetchPaymentMethods()
      videoData.value.video = video
      videoData.value.match = null
      videoData.value.price = video.video_price
      videoData.value.paymentMethodsParams = paymentMethods.value
      await updateVideoData(videoData.value)
    }

    const onWatchVideo = async video => {
      if (video.entity === 'video') {
        if (!video.show_video_type) {
          videoData.value.video = video
          await updateVideoData(videoData.value)

          const hash = video.video_share_url.split('/r/')[1]
          router.push({
            name: 'recording',
            params: {
              hash,
            },
          })
        } else {
          await onLoadVideo(video)
          router.push({ name: 'views-video-quality' })
        }
      } else {
        await onLoadVideo(video)
        router.push({ name: 'views-video-checkout' })
      }
    }

    const openUpdateShare = async val => {
      isDialogShare.value = val
    }

    const onShare = video => {
      try {
        if (isSupportedShare.value) {
          shareURL(
            'Fanaty',
            `Date: ${formatVideoName(`${video.register_date} ${video.video_start_time}`)}\nTime: ${video.video_start_time} (${video.video_min_long} mins)\nLocation: ${video.facility_name} • ${video.field_name}\n\nManage booking:\n${video.video_share_url}\n\nVideo recording available via the link.`,
            video.video_share_url,
          )
        } else {
          shareData.value = {
            link: video.video_share_url,
            sport: `${facilitySelected.value.name} • ${video.field_name}`,
            date: formatVideoName(`${video.register_date} ${video.video_start_time}`),
            startTime: `${video.video_start_time} (${video.video_min_long} mins)`,
            location: `${facilitySelected.value.name} • ${video.field_name}`,
          }
          openUpdateShare(true)
        }
      } catch (e) {
        console.error(e)
        shareData.value = {
          link: video.video_share_url,
          sport: `${facilitySelected.value.name} • ${video.field_name}`,
          date: formatVideoName(`${video.register_date} ${video.video_start_time}`),
          startTime: `${video.video_start_time} (${video.video_min_long} mins)`,
          location: `${facilitySelected.value.name} • ${video.field_name}`,
        }
        openUpdateShare(true)
      }
    }

    const openCloseReport = async val => {
      isDialogReport.value = val
    }

    const isPaass = (dateA, dateB) => {
      const date1 = new Date(dateA)
      const date2 = new Date(dateB)

      return date1 < date2
    }

    const isFuture = (dateA, dateB) => {
      const date1 = new Date(dateA)
      const date2 = new Date(dateB)

      return date1 > date2
    }

    onBeforeMount(() => {
      Vue.directive('infinite-scroll', infiniteScroll)
    })

    onMounted(async () => {
      await localStorage.removeItem('matchCode')
      const {
        facility,
        field,
        date,
        time,
      } = route.value.params

      privateLanding.value = !!userData.value

      Object.assign(videoData.value, currentVideoData.value)
      await clearLogData()
      if (facility && facility !== 'all' && field && date && time) {
        const pass = isPaass(date, minDate.value)
        const future = isFuture(date, maxDate.value)

        // const dateStr = date !== 'all' ? pass ? minDate.value : date : maxDate.value
        let dateStr = maxDate.value
        if (date !== 'all') {
          if (date) dateStr = date
          if (pass) dateStr = minDate.value
          if (future) dateStr = maxDate.value
        }
        const facilityId = facility !== 'all' ? parseInt(facility, 10) : null
        const fieldId = field !== 'all' ? parseInt(field, 10) : null
        const timeStr = time !== 'all' ? time : null
        refreshRoure()

        await fetchFacilities()
        const facilityFinded = facilities.value.find(e => e.id === facilityId)
        if (facilityFinded) {
          facilityIdSelected.value = facilityId
          facilitySelected.value = facilityFinded
          fields.value = facilityFinded.fields
        }
        fieldFilter.value = fieldId
        dateFilter.value = dateStr
        timeFilter.value = timeStr
      } else if (videoData.value.facility && videoData.value.facility.id) {
        facilityIdSelected.value = videoData.value.facility.id
        facilitySelected.value = videoData.value.facility
        fields.value = videoData.value.facility.fields

        await fetchFacilities()
      } else router.push({ name: 'views-facility-list' })
    })

    return {
      // data
      shareData,
      isDialogShare,
      privateLanding,
      isDialogReport,
      userData,
      facilitySelected,
      facilityIdSelected,
      facilities,
      fields,
      startTimes,
      recordings,
      hasRecordings,
      lastItemId,

      minDate,
      maxDate,
      modal,
      dateFilter,
      fieldFilter,
      timeFilter,
      computedDateFormatted,

      busy,
      onLoadMore,

      // methods
      formatCurrency,
      formatVideoName,
      onLogin,
      onLogout,
      onWatchVideo,
      openCloseReport,
      onReportIssue,
      openUpdateShare,
      onShare,

      fetchFacilities,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      t,

      icons: {
        mdiCalendarOutline,
        mdiSoccerField,
        mdiClockOutline,
        mdiInformationOutline,
        mdiShareOutline,
      },
    }
  },
}
